import React from 'react'
import Link from '@material-ui/core/Link'
import LaunchOutlinedIcon from '@material-ui/icons/LaunchOutlined'
import { authenticatedRedirectLink } from 'lib/pga-dot-coach'
import SectionBase from './SectionBase'

export default () => (
  <SectionBase
    titleText="We provide the SEO, web traffic and potential students so you can
    focus on your students. And when used in conjunction with PGA
    Calendar, students can book time with you directly on PGA.com!"
    gtmLearnObject={{
      event: 'onboarding-click',
      onboardingCategory: 'onboarding-dashboard',
      onboardingLabel: 'create-profile',
      onboardingAction: 'click-learn-more',
    }}
    learnMoreLink="https://support.pga.com/en/articles/4724849-profile-quick-start"
    gtmDoActionObject={{
      event: 'onboarding-click',
      onboardingCategory: 'onboarding-dashboard',
      onboardingLabel: 'create-profile',
      onboardingAction: 'click-get-started',
    }}
    doActionLink="/pga-coach/profile"
    doActionText="Create your Profile"
    extraTitleLine={
      <>
        {
          'For educational content on maximizing the impact of your coach profile, visit '
        }
        <Link
          style={{ fontWeight: 600 }}
          target="_blank"
          href={authenticatedRedirectLink('/trainingCenter/category/27703')}
        >
          PGA Coach Tools and Resources
          <LaunchOutlinedIcon fontSize="inherit" />
        </Link>
        {'.'}
      </>
    }
  />
)
